import * as React from "react";
import EventHelper from "common/helpers/eventHelper/eventHelper";
import "./EventHeroBanner.scss";

export default function EventHeroBanner({
	image,
	title,
	subtitle,
	onCaptionClick,
	children,
}) {
	return (
		<div
			className="hero-banner"
			style={{
				backgroundImage: `url("${EventHelper.getEventImageUrl({ image })}")`,
			}}
		>
			{children}
			<div
				className={`hero-caption${onCaptionClick ? " clickable" : ""}`}
				onClick={onCaptionClick}
			>
				<h3>{title}</h3>
				<label>{subtitle}</label>
			</div>
		</div>
	);
}
